import styled from 'styled-components';
import { media } from '../../../public/styles';

export const Container = styled.div`
	display: flex;
	gap: 8px;
	flex-direction: row;

	> div {
		flex: 1;
	}
`;
export const RowOnDesktopColumnOnMobile = styled.div`
	display: flex;
	gap: 16px;
	flex-direction: row;

	> :first-child {
		flex: 2;
	}

	> :last-child {
		flex: 1;
	}

	@media ${media.smaller} {
		display: flex;
		flex-direction: column;
	}
`;

export const JobFunctionControls = styled.div`
	display: flex;
	gap: 8px;
	flex-direction: row;

	> div {
		flex: 1;
	}

	@media ${media.smaller} {
		flex-direction: column;
		gap: 0;
	}
`;

export const JobFunctionDescriptionContainer = styled.div`
	padding: 26px 0 0 0;

	@media ${media.smaller} {
		padding: 8px 0 0 0;
	}
`;

export const LegalBusinessNameContainer = styled.div`
	display: none;
`;
